export const STATUS_OPTIONS = [
  { value: "requested", label: "Requested" },
  { value: "approved", label: "Approved" },
  { value: "rejected", label: "Rejected" },
  { value: "", label: "All" },
];

export const DEFAULT_HUB_ID = 1;

export const MESSAGE_TOP_OFFSET = 50;

export const DEFAULT_PAGE_SIZE = 10;

export const ERROR_MESSAGES = {
  FETCH_FAILED: "Failed to load RTO request data",
  STATUS_UPDATE_FAILED: (nextStatus, awbNumber) => `Failed to ${nextStatus} for AWB ${awbNumber}`,
};

export const SUCCESS_MESSAGES = {
  STATUS_UPDATED: (nextStatus, awbNumber) => `Status ${nextStatus} for AWB ${awbNumber}`,
};

export const STATUS_COLORS = {
  APPROVED: "#52c41a",
  REJECTED: "#ff4d4f",
};

export const approveButtonStyle = (isDisabled) => ({
  backgroundColor: STATUS_COLORS.APPROVED,
  borderColor: STATUS_COLORS.APPROVED,
  color: "#fff",
  opacity: isDisabled ? 0.5 : 1,
  cursor: isDisabled ? "not-allowed" : "pointer",
});

export const rejectButtonStyle = (isDisabled) => ({
  backgroundColor: STATUS_COLORS.REJECTED,
  borderColor: STATUS_COLORS.REJECTED,
  color: "#fff",
  opacity: isDisabled ? 0.5 : 1,
  cursor: isDisabled ? "not-allowed" : "pointer",
});
